module.exports = __webpack_public_path__ + "img/nol-back.86cee95c.png";